module.exports = __webpack_public_path__ + "img/button-arrow.svg";